// src/pages/Callback.tsx
import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "../api";
import Cookies from "js-cookie";

export default function Callback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
  const handleAuth = async () => {
  try {
    const returnUrl = params.get("returnUrl") || "/"; 
    console.log("returnUrl", returnUrl);
    // if (!returnUrl) {
    //   alert("Invalid url");
    //   navigate("/login");
    //   return;
    // }

    // const refreshToken = Cookies.get("refresh_token");console.log("refreshToken",refreshToken)
  //  const tokenResponse = await api.post(`/auth/decode-token`, {
  //       method: "POST",
  //       // withCredentials: true,
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       // credentials: "include", // allows backend to set cookies
  //       // body: JSON.stringify({ auth_code }),
  //     });

    const tokenResponse = await api.post("/auth/decode-token", {}, { withCredentials: true });

    if (!tokenResponse?.data?.decoded) {
          // alert("Invalid login session");
             window.location.href = `${process.env.REACT_APP_Flexm}`
          return;
        }

   const { loginId, tenantId } = tokenResponse.data.decoded;

      if (!loginId || !tenantId) {
      // alert("Invalid login session");
      // navigate("/login"); 
      window.location.href = `${process.env.REACT_APP_Flexm}`
  
    }


    const redirectUri = encodeURIComponent(
      process.env.REACT_APP_REDIRECT_URI || ""
    );

    // Step 1: Request auth_code
    const authorizeRes = await api.get(
      `/auth/authorize?login_id=${loginId}&tenant_id=${tenantId}&redirect_uri=${redirectUri}`
    );

    const { auth_code } = authorizeRes.data;

    // Step 2: Redirect with auth_code
    if(returnUrl === "/"){
     window.location.href = `${process.env.REACT_APP_Flexm}/?code=${auth_code}`;

    }else{
    window.location.href = `${process.env.REACT_APP_Flexm}/?code=${auth_code}&returnUrl=${returnUrl}`;
    }
    // Step 3: Save session
    // localStorage.setItem("access_token", access_token);
    // localStorage.setItem("refresh_token", refresh_token);
    // localStorage.setItem("user", JSON.stringify(user));

    // Step 4: Go to home (if no redirect)
    // navigate("/home");

  } catch (err: any) {
    // alert(err?.response?.data?.message || "Authentication failed");
    window.location.href = `${process.env.REACT_APP_Flexm}`
  }
};

    handleAuth();
  }, [params, navigate]);

  return (
    <div className="flex items-center justify-center h-screen">
      <p className="text-lg font-semibold">Please wait, you are being login...</p>
    </div>
  );
}
